import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import styles from './SendEmailForm.module.scss';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';
import { usePost } from 'hooks/usePost';
import { workflow } from 'hooks/endpoints';
import Input from 'component/atom/forms/input/input/Input';

const SendEmailForm = ({ id }) => {
  const formik = useFormikContext();
  const [editingIndex, setEditingIndex] = useState(null);

  const { mutate: generateMessageVariants, isPending } = usePost();

  const handleGenerateMessageVariants = (message) => {
    generateMessageVariants(
      {
        url: workflow.autoGenerateMessageVariants,
        data: { message: message },
        isFormData: false,
      },
      {
        onSuccess: (data) => {
          const cleanedVariants = (data?.data?.result || []).filter(
            (v) => v.trim() !== ''
          );
          formik.setFieldValue('messageVariant', cleanedVariants);
        },
      }
    );
  };

  return (
    <form
      className={styles['message-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['editor-container']}>
        <Input
          placeholder='Enter Email'
          label='To'
          value={formik.values.to}
          name='to'
          onChange={(e) => formik.setFieldValue('to', e.target.value)}
          error={formik.errors.to}
          touched={formik.touched.to}
          onBlur={formik.handleBlur}
        />
        <Input
          placeholder='Enter Subject'
          label='Subject'
          value={formik.values.subject}
          name='subject'
          onChange={(e) => formik.setFieldValue('subject', e.target.value)}
          error={formik.errors.subject}
          touched={formik.touched.subject}
          onBlur={formik.handleBlur}
        />
        <TextEditor
          placeholder='Enter your custom message...'
          name='message'
          value={formik.values.message}
          onChange={(value) => formik.setFieldValue('message', value)}
          error={formik.errors.message}
          touched={formik.touched.message}
          rows='15'
          className={styles['editor']}
          isCustom
          isToolbarReduced
          textEditorClassName={styles['editor-class']}
        />
      </div>
    </form>
  );
};

export default SendEmailForm;
